class VideoPlayer {
    constructor(opts) {
        this.videoProgressWrap = opts.videoProgressWrap;
        this.videoPoster =  opts.videoPoster;
        this.btnMuted = opts.btnMuted;
        this.btnPlay = opts.btnPlay;
        this.videoEle = opts.videoEle;
        this.progressBar = opts.progressBar;
        this.muted = opts.muted;
        this.autoplay = opts.autoplay;
        this.duration = 0;
        this.currentTime = opts.currentTime || 0;
        this.init();// 初始化video播放器
    }

    set paused(paused) {
        this.videoEle.paused = paused
    }

    get paused() {
        return this.videoEle.paused
    }

    set ended(ended) {
        this.videoEle.ended = ended
    }

    get ended() {
        return this.videoEle.ended
    }


    init() {
        this.videoEle.setAttribute('crossorigin', 'anonymous');
        this.videoEle.load();
        this.bindMutedEvent();
        this.bindPlayEvent();
        if (this.autoplay) {
            this.play();
        }
        this.setMuted(this.muted);// 设置静音状态
        this.initProgress(); // 初始化滚动条
    }

    setMuted(mute) {
        let ret = false

        if (this.videoEle.muted !== mute) {
            const muted = this.videoEle.muted
            //console.log('设置静音前---：', videoEl.muted, muted, muteOpt)
            this.videoEle.muted = mute
            //判断是否设置成功 ios9以下设置video.muted属性无效
            if (muted !== this.videoEle.muted) {
                this.muted = mute
                this.videoEle.muted = mute;
                ret = true
            } else {
                ret = false
            }
        } else {
            ret = true
        }

        if (this.muted) {
            this.btnMuted.classList.remove("icon-unmuted");
        } else {
            this.btnMuted.classList.add("icon-unmuted");
        }

        return ret
    }

    /*
    stop(){
        this.videoEle.currentTime = 0
    }
    */

    pause() {
        this.videoEle.pause()
        this.btnPlay.classList.remove("hide");
        console.log("视频暂停")
    }

    play() {
        let _this = this;
        try {
            let videoIsPlay = _this.videoEle.play();
            const playAction=()=>{
                _this.videoEle.play();
                // 隐藏播放按钮
                _this.btnPlay && _this.btnPlay.classList.add("hide");
                // 隐藏自定义封面图
                try{
                    // 延迟300ms隐藏，避免太过明显的原生播放器播放按钮展示出来
                    setTimeout(()=>{
                        _this.videoPoster && _this.videoPoster.classList.add("hide");
                    },300)
                }catch(err){
                    _this.videoPoster && _this.videoPoster.classList.add("hide");
                }
            }
            console.log("视频准备播放")
            if (videoIsPlay !== undefined) {
                videoIsPlay.then(() => {
                    playAction()
                }).catch((err) => {
                    console.log(err);
                    playAction()
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    showProgress() {
        this.videoProgressWrap.style.opacity = "1";
    }

    showMutedBtn() {
        this.btnMuted.classList.add("show");
    }

    showPlayBtn() {
        this.btnPlay.classList.add("show");
    }

    hideProgress() {
        this.videoProgressWrap.style.opacity = "0";
    }

    hideMutedBtn() {
        this.btnMuted.classList.add("hide");
    }

    hidePlayBtn() {
        this.btnPlay.classList.add("hide");
    }

    initProgress() {
        let _this = this;
        _this._bindEvent(_this.videoEle, 'canplay', function () {
            _this.duration = this.duration;
        })
        // 如果指定第几秒开始播放
        if (_this.currentTime) {
            _this.videoEle.currentTime = _this.currentTime
        }
        _this._bindEvent(_this.videoEle, 'timeupdate', function () {
            _this.currentTime = this.currentTime;
            let percent = (_this.currentTime / _this.duration) * 100;
            _this.progressBar.style.width = percent + '%'
        })
    }

    bindMutedEvent() {
        let _this = this;
        _this._bindEvent(_this.btnMuted, "click", function (e) {
            _this.setMuted(!_this.muted);
            e.stopPropagation()
        })
    }

    bindPlayEvent() {
        let _this = this;
        _this._bindEvent(_this.btnPlay, "click", function (e) {
            _this.btnPlay.classList.add("hide");
            _this.play();
            e.stopPropagation()
        })
    }

    _bindEvent(el, eventName, listener) {
        el.addEventListener(eventName, listener, false)
    }

    onVideoClick(cb) {
        cb && this._bindEvent(this.videoEle, 'click', cb)
    }

    onMuteButtonClick(cb) {
        cb && this._bindEvent(this.btnMuted, 'click', cb)
    }

    onLoadError(cb) {
        cb && this._bindEvent(this.videoEle, 'error', cb)
    }
}

export default VideoPlayer